"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _manager = require("../../constants/manager");
var _uiLogger = _interopRequireDefault(require("@ow/ui-logger"));
var _searchInsights = _interopRequireDefault(require("search-insights"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function listener(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    type = _ref2[0],
    payload = _ref2[1];
  switch (type) {
    case _manager.EVENT:
      {
        var name = payload.name,
          data = payload.data;
        if (name === _manager.events.ALGOLIA_CLICK_THROUGH) {
          try {
            var index = data.index,
              eventName = data.eventName,
              queryID = data.queryID,
              objectIDs = data.objectIDs,
              positions = data.positions;
            (0, _searchInsights.default)('clickedObjectIDsAfterSearch', {
              index: index,
              eventName: eventName,
              queryID: queryID,
              objectIDs: objectIDs,
              positions: positions
            });
          } catch (err) {
            (0, _uiLogger.default)().error({
              err: err
            }, 'Algolia Insights: clickedObjectIDsAfterSearch failed');
          }
        } else if (name === _manager.events.ALGOLIA_CONVERSION) {
          try {
            var _index = data.index,
              _eventName = data.eventName,
              _queryID = data.queryID,
              _objectIDs = data.objectIDs;
            (0, _searchInsights.default)(_queryID ? 'convertedObjectIDsAfterSearch' : 'convertedObjectIDs', _objectSpread({
              index: _index,
              eventName: _eventName,
              objectIDs: _objectIDs
            }, _queryID && {
              queryID: _queryID
            }));
          } catch (err) {
            (0, _uiLogger.default)().error({
              err: err
            }, 'Algolia Insights: convertedObjectIDsAfterSearch failed');
          }
        } else if (name === _manager.events.ALGOLIA_ADD_TO_CART) {
          try {
            var _index2 = data.index,
              _eventName2 = data.eventName,
              _queryID2 = data.queryID,
              _objectIDs2 = data.objectIDs,
              objectData = data.objectData,
              currency = data.currency;
            (0, _searchInsights.default)(_queryID2 ? 'addedToCartObjectIDsAfterSearch' : 'addedToCartObjectIDs', _objectSpread({
              index: _index2,
              eventName: _eventName2,
              objectIDs: _objectIDs2
            }, _queryID2 && {
              queryID: _queryID2
            }, objectData && objectData.length === _objectIDs2.length && {
              objectData: objectData,
              currency: currency || 'AUD'
            }));
          } catch (err) {
            (0, _uiLogger.default)().error({
              err: err
            }, 'Algolia Insights: addedToCartObjectIDsAfterSearch failed');
          }
        }
        break;
      }
  }
}
var _default = listener;
exports.default = _default;